import { reactive, ref, watch } from 'vue';

interface UseCreateBudgetGroupDialogState {
  isOpen: boolean;
}

const state = reactive<UseCreateBudgetGroupDialogState>({ isOpen: false });
const isRendered = ref(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
});

export function useCreateBudgetGroupDialog() {
  function open() {
    state.isOpen = true;
  }

  function close() {
    state.isOpen = false;
  }

  return {
    state,
    isRendered,
    open,
    close,
  };
}
